export default __webpack_public_path__ + "c32eaa893a2c354759c40a1f1db65044.png";